<script>
export default {
    name: "AgeCalculatorForm",

    data() {

        return {
            age: null,
        }
    },

    props: {
        showModal: Boolean,
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/6 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Calculate Age</h5>
      </template>
      <template v-slot:modal-body>
        <div class="-m-4 flex flex-wrap">
          <div class="w-full p-tiny">
              <label for="grid-enter-age" class="label-control">Enter Age:</label>
              <input type="number" min="1" v-model="age" id="grid-enter-age" class="w-12 input-control text-right">
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-4" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="$emit(`parseAge`, age)"><i class="fa fa-calculator"></i> Calculate Age</button>
      </template>
    </tail-modal>
</template>